export const ProgressAssessment = {
    NoObservations: 'NoObservations',
    OnTrack: 'OnTrack',
    Ahead: 'Ahead',
    Behind: 'Behind',
};

export const ObservationVariant = {
    ASSESSMENT: 'ASSESSMENT',
    REGULAR_OBSERVATION: 'REGULAR_OBSERVATION',
    UP_TO_SPEED_OBSERVATION: 'UP_TO_SPEED_OBSERVATION',
    TWO_YEAR_PROGRESS: 'TWO_YEAR_PROGRESS',
    PARENT_OBSERVATION: 'PARENT_OBSERVATION',
};

export const Refinements = {
    EMERGING: 'EMERGING',
    DEVELOPING: 'DEVELOPING',
    SECURE: 'SECURE',
};
